<template>
  <color-picker
    :label="$t('edit.sidebar.text_color')"
    id="triggerButtonTextColor"
    :value="boxConfig.trigger_button.style.color"
    :change="onColorChange"
    :move="onMove"
  ></color-picker>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ColorPicker from '../../../general/ColorPicker.vue';

export default {
  components: {
    ColorPicker,
  },
  methods: {
    onColorChange(color) {
      this.boxUpdateConfigStyle({ item: 'trigger_button', rule: 'color', value: color });
    },
    onMove(color) {
      this.boxPreviewConfigStyleChange({ item: 'trigger_button', rule: 'color', value: color });
    },
    ...mapActions([
      'boxUpdateConfigStyle',
      'boxPreviewConfigStyleChange',
    ]),
  },
  computed: mapGetters({
    boxConfig: 'boxConfig',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** TextColor.vue?2e2d6993
 **/